<template>
  <div class="row">
    <div class="col s12" data-step="4" :style="`--step-color:#ffab00`">
      <div id="final-selection-guide" class="card waves-effect waves-block hoverable" @click="$_adaptation()">
        <div class="card-content">
          <div class="icon">
            <img :src="adapticon" alt="Act to Adapt" />
          </div>
          <div class="info-container">
            <div class="title">Write your Adaptation Plan!</div>
            <div class="text grey-text text-darken-3">
              Follow this outline to prepare your Home
              Adaptation Plan.
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col s12" data-step="5" :style="`--step-color:#536dfe`" v-if="false">
      <div id="final-selection-guide" class="card waves-effect waves-block hoverable" @click="$_goToGuidesTutorials()">
        <div class="card-content">
          <div class="icon">
            <img :src="appLogo" alt="Act to Adapt" />
          </div>
          <div class="info-container">
            <div class="title">Enter the Competition!</div>
            <div class="text grey-text text-darken-3">
              Enter the SLDB <em>Act to Adapt</em> Competition for a
              chance to win big to help implement your proposed
              adaptation and mitigation measures.
              <p style="font-weight:600; margin-top:8px;">
                You must be a homeowner to enter the
                Competition.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import appLogo from "@/assets/act_to_adapt@2x.png";
import adapticon from "@/assets/adaptation_plan.svg";
/* import resourceCentre from '@/assets/resource_centre.svg' */
export default {
  name: "finalSectionGuide",
  props: {},
  data() {
    return {
      appLogo,
      adapticon,
    };
  },
  mounted() { },
  computed: {},
  methods: {
    $_adaptation() {
      this.$router.push({ name: "adaptationPlan" });
    },
    $_goToGuidesTutorials() {
      return
      this.$router.push({ name: "competition" });
      /* console.log("Go to guides and tutorials page"); */
    },
  },
};
</script>
<style lang="scss" scoped>
#final-selection-guide {
  .card-content {
    display: flex;
    align-items: center;

    @media screen and (max-width: 580px) {
      flex-wrap: wrap;
    }

    .icon {
      margin-right: 1rem;

      img {
        width: 124px;
      }

      i {
        font-size: 42px;
      }

      @media screen and (max-width: 580px) {
        text-align: center;
        width: 100%;

        img {
          margin: 0px;
          width: 170px;
        }
      }
    }

    .title {
      font-size: 20px;
    }
  }
}

.col[data-step="4"] {
  position: relative;
  margin-top: 32px;
}

.col[data-step="4"]:before {
  content: " ";
  border: 2px solid #ffab00;
  border-bottom: none;
  position: absolute;
  left: 0px;
  top: -20px;
  width: 100%;
  height: 28px;
  border-radius: 5px 5px 0 0;
}

.col[data-step="4"]:after {
  text-align: center;
  content: "Step 4";
  position: absolute;
  color: #ffab00;
  top: -31px;
  left: 50%;
  width: 90px;
  background: white;
  transform: translateX(-50%);
  text-transform: uppercase;
  font-size: 14px;
  letter-spacing: 1px;
  border-radius: 7px;
  padding: 3px 0;
  font-weight: 600;
}

.col[data-step="4"],
.col[data-step="5"] {
  position: relative;
  margin-top: 32px;
}

.col[data-step="5"]:before {
  content: " ";
  border: 2px solid #536dfe;
  border-bottom: none;
  position: absolute;
  left: 0px;
  top: -20px;
  width: 100%;
  height: 28px;
  border-radius: 5px 5px 0 0;
}

.col[data-step="5"]:after {
  text-align: center;
  content: "Step 5";
  position: absolute;
  color: #536dfe;
  top: -31px;
  left: 50%;
  width: 90px;
  background: white;
  transform: translateX(-50%);
  text-transform: uppercase;
  font-size: 14px;
  letter-spacing: 1px;
  border-radius: 7px;
  padding: 3px 0;
  font-weight: 600;
}
</style>
